export type Theme = typeof lightTheme;

const commonTokens = {
    maxContentWidth: "500px",

    colors: {
        white: "#ffffff",
        warning: "#f16a1b",
        black: "#000000",
        green: "#49AA19",

        primary: "#3A57E8",

        yellowAccent: "#FFD60A",
    },
};

export const lightTheme = {
    ...commonTokens,
    primaryTypographyColor: "#000000",
    secondaryTypographyColor: "#4F4F4F",
    disabledTypographyColor: "#9c9c9c",
    dangerTypographyColor: "#D32F2F",
    successTypographyColor: "#388E3C",
    additionalTypographyColor: "#1E88E5",
    secondaryBackgroundColor: "#ECECEC",
    secondaryBorderColor: "#CECECE",
    primaryBackground: "#e7e7e7",
    secondaryBackground: "#ffffff",
    collapseHeaderBackground: "#ECECEC",
    tabsAPBackground: "#D3D3D4",
    activeTabAPBackground: "#ffffff",
    shelfValueColor: "#5F5F5F",
    inactiveTabColor: "#313131",
    activeTabColor: "#000000",
    selectedCalendarDaysColor: "#8eb0f0",
    checkboxBorder: "#D3D3D4",
    darkBlue: "#BAE0FF",
    middleBlue: "#69B1FF",
    lightBlue: "#002C8C",
    itemBackground: "#f9f9f9",
    itemBorder: "#2563eb",
    alertColor: "#ff0000",
    infoBackground: "#EAF2FF",
};

export const darkTheme: Theme = {
    ...commonTokens,
    primaryTypographyColor: "#ffffff",
    secondaryTypographyColor: "#D3D3D4",
    disabledTypographyColor: "#a8a8a8",
    dangerTypographyColor: "#BF2E2D",
    successTypographyColor: "#49AA19",
    additionalTypographyColor: "#1677FF",
    secondaryBackgroundColor: "#141414",
    secondaryBorderColor: "#313131",
    primaryBackground: "#181818",
    secondaryBackground: "#000000",
    collapseHeaderBackground: "#141414",
    tabsAPBackground: "#3a3a3a",
    activeTabAPBackground: "#000",
    shelfValueColor: "#5F5F5F",
    inactiveTabColor: "#ffffff",
    activeTabColor: "#D3D3D4",
    selectedCalendarDaysColor: "#2f4d88",
    checkboxBorder: "#5F5F5F",
    darkBlue: "#111A2C",
    middleBlue: "#15325B",
    lightBlue: "#8DC5F8F8",
    itemBackground: "#262626",
    itemBorder: "#3c89e8",
    alertColor: "#ffd900",
    infoBackground: "#111A2C",
};
